import {customElement, bindable, inject} from 'aurelia-framework';
import {Client} from '../api/client';
import {MongoDataLoader} from "../table/loader/mongo-data-loader";
import {FlashService} from "../flash/flash-service";
import {I18N} from "aurelia-i18n";
import * as _ from 'lodash';
import moment from 'moment';

@customElement('sio-availability-calendar')
@inject(Client, FlashService, I18N)
export class AvailabilityCalendar
{
    @bindable user;

    @bindable departments;

    choiceConfig = {
        modelId: 'user/department',
        multiple: true,
    };

    constructor(client)
    {
        this.client = client;
        this.callback = this.loadEvents.bind(this);
    }

    loadEvents(config, startDate, endDate)
    {
        let conditions = {
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD')
        };

        if (this.user) {
            conditions.users = [this.user];
        } else if (this.departments) {
            conditions.users = this.departments;
        }

        let query = $.param(conditions);

        return this.client.get('human-resources/availability?' + query).then(results => {

            let modified = [];

            _.each(results, result => {

                let endDate = result.endDate;

                if (endDate != result.startDate && result.allDay) {
                    endDate = moment(result.endDate).add(1, 'days').format('YYYY-MM-DD');
                }

                modified.push({
                    start: result.startDate,
                    end: endDate,
                    allDay: result.allDay,
                    title: result.title,
                    color: result.color
                })
            });

            return modified;
        });
    }

    departmentsChanged()
    {
        this.calendar.reload();
    }
}